import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";

// Тема EyeTech/Lexa (скопирована verbatim) + общие CSS-токены
import "./assets/scss/theme.scss";
import "./styles/design-tokens.css";
import "./styles/list-page-layout.css";
import "./styles/components/action-buttons-base.css";

import { userRoutes, authRoutes } from "./routes/allRoutes";
import Authmiddleware from "./routes/middleware/Authmiddleware";
import RequireRole from "./routes/middleware/RequireRole";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Loading fallback для lazy-loaded компонентов (фич-страниц)
const LoadingFallback = () => {
  const { t } = useTranslation("common");
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{t("loading")}</span>
      </div>
    </div>
  );
};

const App = () => {
  const renderComponent = (route) => {
    // Элементы-редиректы (Navigate) не требуют проверки ролей.
    if (route.element) {
      return route.element;
    }
    return (
      <RequireRole roles={route.roles ?? null}>
        <Suspense fallback={<LoadingFallback />}>
          <route.component />
        </Suspense>
      </RequireRole>
    );
  };

  const renderRoutes = (routes) =>
    routes.map((route, idx) => (
      <Route key={idx} path={route.path} element={renderComponent(route)} />
    ));

  return (
    <>
      <Routes>
        {/* Публичные (auth) маршруты — в NonAuthLayout */}
        {authRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <NonAuthLayout>
                <Suspense fallback={<LoadingFallback />}>
                  {route.element ? route.element : <route.component />}
                </Suspense>
              </NonAuthLayout>
            }
          />
        ))}

        {/* Защищённое дерево — Authmiddleware > VerticalLayout(Outlet) */}
        <Route
          path="/"
          element={
            <Authmiddleware>
              <VerticalLayout />
            </Authmiddleware>
          }
        >
          {renderRoutes(userRoutes)}
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default App;
